
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/bb961440-a650-4543-bd88-152698c0f8f2.png"
              alt="Digital Domination LLC"
              className="h-12 w-auto"
            />
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/')
                  ? 'text-orange-600'
                  : isScrolled
                  ? 'text-gray-900 hover:text-orange-600'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              Products & Services
            </Link>
            <Link
              to="/refund-policy"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/refund-policy')
                  ? 'text-orange-600'
                  : isScrolled
                  ? 'text-gray-900 hover:text-orange-600'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              Refund Policy
            </Link>
            <Link
              to="/privacy-policy"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/privacy-policy')
                  ? 'text-orange-600'
                  : isScrolled
                  ? 'text-gray-900 hover:text-orange-600'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              Privacy Policy
            </Link>
            <a
              href="mailto:domination@thompsondigital.org"
              className="px-6 py-2.5 bg-orange-600 text-white text-sm font-semibold rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap"
            >
              Contact Us
            </a>
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2"
            aria-label="Toggle menu"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span
                className={`block h-0.5 w-full transition-all ${
                  isScrolled ? 'bg-gray-900' : 'bg-white'
                }`}
              ></span>
              <span
                className={`block h-0.5 w-full transition-all ${
                  isScrolled ? 'bg-gray-900' : 'bg-white'
                }`}
              ></span>
              <span
                className={`block h-0.5 w-full transition-all ${
                  isScrolled ? 'bg-gray-900' : 'bg-white'
                }`}
              ></span>
            </div>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 text-sm font-medium ${
                isActive('/') ? 'text-orange-600' : 'text-gray-900'
              }`}
            >
              Products & Services
            </Link>
            <Link
              to="/refund-policy"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 text-sm font-medium ${
                isActive('/refund-policy') ? 'text-orange-600' : 'text-gray-900'
              }`}
            >
              Refund Policy
            </Link>
            <Link
              to="/privacy-policy"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 text-sm font-medium ${
                isActive('/privacy-policy') ? 'text-orange-600' : 'text-gray-900'
              }`}
            >
              Privacy Policy
            </Link>
            <a
              href="mailto:domination@thompsondigital.org"
              className="block py-2 text-sm font-medium text-orange-600"
            >
              Contact Us
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
